import { Record, String, Array, Number, Unknown } from "runtypes";
import type { Static } from "runtypes";
import { TickerStatus } from "./TickerStatus";
import { ChangeLogEntry } from "./ChangeLogEntry";

export const Ticker = Record({
  creationByUser: String,
  creationDate: String,
  exchange: String,
  id: String,
  lastUpdatedByUser: String.nullable(),
  lastUpdatedDate: String.nullable(),
  name: String,
  dataProviderId: String.nullable().optional(),
  notes: String.nullable().optional(),
  companyLogoUrl: String.nullable().optional(),
  companyBannerUrl: String.nullable().optional(),
  companyUrl: String.nullable().optional(),
  companyTaxId: String.nullable().optional(),
  companyLegalName: String.nullable().optional(),
  pricingTier: String.nullable().optional(),
  status: TickerStatus,
  type: String.nullable(),
  symbol: String,
  changeLog: Array(ChangeLogEntry).optional(),
  lastImportedByUser: String.nullable().optional(),
  lastImportedDate: String.nullable().optional(),
  investmentScoreAnalytical: Number.nullable().optional(),
  investmentScoreSentiment: Number.nullable().optional(),
  overallInvestmentScore: Number.nullable().optional(),
  country: String.nullable().optional(),
  stateOrProvince: String.nullable().optional(),
  city: String.nullable().optional(),
  yearFounded: Number.nullable().optional(),
  industries: Array(String).optional(),
  marketCap: Number.nullable().optional(),
  fairValue: Number.nullable().optional(),
  sellRating: Unknown.nullable().optional(), // TODO: Is set to Number in API but strings being passed??
  ipoStatus: String.nullable().optional(),
  revenue: Number.nullable().optional(),
  companyTradingStatus: String.nullable().optional(),
  companyStockExchangeStatus: String.nullable().optional(),
  address: String.nullable().optional(),
  companyDescription: String.nullable().optional(),
  companyType: String.nullable().optional(),
  companyLegalStructure: String.nullable().optional(),
  companyLinkedinUrl: String.nullable().optional(),
  companyCrunchbaseUrl: String.nullable().optional(),
  companyCreditScore: String.nullable().optional(),
  dataProviderConfidenceScore: String.nullable().optional(),
  raisingCapital: String.nullable().optional(),
  raisingCapitalAmount: String.nullable().optional(),
  revenueGrowthRate: Number.nullable().optional(),
  numberOfEmployees: Number.nullable().optional(),
  inferredDashboardMetrics: Unknown.optional(),
  inferredCompanyStage: String.nullable().optional(),
  inferredIndustries: Array(String).optional(),
  inferredGrowthRate: Number.nullable().optional(),
  inferredRevenue: Number.nullable().optional(),
  aliases: Array(String).optional(),
});

export type Ticker = Static<typeof Ticker>;
